<template>
  <div class="mobile-contact-wrap">
    <Header />
    <div class="content">
      <div class="name-wrap">联系我们 (Contact Us)</div>
      <div class="desc-wrap">
        <div class="left">
          <van-icon name="wap-home-o" />公司门市部:
        </div>
        <div class="right">中国浙江省台州市黄岩区鉴湖村(梅山223号)</div>
      </div>
      <div class="desc-wrap">
        <div class="left">
          <van-icon name="phone-o" />手机(M.P):
        </div>
        <div class="right">13905764593(张先生)</div>
      </div>
      <div class="desc-wrap">
        <div class="left">
          <van-icon name="service-o" />售后服务(Tel):
        </div>
        <div class="right">086-18257620988</div>
      </div>
      <div class="desc-wrap">
        <div class="left">
          <van-icon name="envelop-o" />邮编(P.c):
        </div>
        <div class="right">318015</div>
      </div>
      <div class="desc-wrap">
        <div class="left">
          <van-icon name="location-o" />地址(add):
        </div>
        <div class="right">浙江省台州市椒江区洪家联合钢材五金市场C区576-582号 <br>
        </div>
      </div>
    </div>
    <div id="map" class="map"></div>
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Bottom from '@/views/mobile/components/Bottom'
export default {
  name: "Contact",
  components: { Header, Bottom },
  mounted(){
    let map = new BMap.Map("map");
    let point = new BMap.Point(121.406011,28.612325);
    map.centerAndZoom(point, 18);
    map.addControl(new BMap.NavigationControl());//添加控件
    map.addControl(new BMap.ScaleControl());
    map.addControl(new BMap.OverviewMapControl());
    map.addControl(new BMap.MapTypeControl());
    map.enableScrollWheelZoom(true);//开启滚动
    var marker = new BMap.Marker(point);        // 创建标注
    map.addOverlay(marker);
  }
}
</script>

<style lang="less" scoped>
.mobile-contact-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  .content {
    margin-top: 0.6rem;
    display: flex;
    flex-direction: column;
    padding: 0 0.32rem;
    margin-bottom: 1rem;
    .name-wrap {
      padding-left: 0.16rem;
      font-size: 0.45rem;
      border-left: 0.2rem solid #3a8ee6;
      margin-bottom: 0.4rem;
    }
    .desc-wrap {
      display: flex;
      margin-top: 0.32rem;
      font-size: 0.46rem;
      .left {
        width: 40%;
      }
      .right {

        width: 70%;
      }
    }
    .picture {
      width: 100%;
      height: 100%;
      margin-bottom: 0.4rem;
    }
  }
  .map {
    width: 100%;
    height: 6rem;
    margin-bottom: 1rem;
  }
}
</style>
